import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=7c09d33e&"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports